import React from "react";
import PageHeader from "../../../../../Components/Bits/PageHeader";

import AgentInboundEvaluations from "../CallCenterAgents/components/AgentInboundEvaluations";
import AgentInboundStatistics from "../CallCenterAgents/components/AgentInboundStatistics";

const AgentEvaluationsHome = () => {
  return (
    <div>
      <PageHeader
        title="Evaluations"
        subtitle="View and manage agent evaluations"
      />

      <>
        <AgentInboundStatistics />
        <AgentInboundEvaluations />
      </>
    </div>
  );
};

export default AgentEvaluationsHome;
